import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientesService } from 'src/app/service/clientes.service';
import { Cliente } from 'src/app/model/cliente.model';
import { ProdutosService } from 'src/app/service/produtos.service';
import { AlertService } from 'src/app/service/alert.service';
import { AgviewsConnectService } from 'src/app/service/agviews-connect.service';

@Component({
  selector: 'app-agviews-connect-atualizar',
  templateUrl: './agviews-connect-atualizar.component.html',
  styleUrls: ['./agviews-connect-atualizar.component.css']
})
export class AgviewsConnectAtualizarComponent implements OnInit {

  tabletForm: FormGroup;
  clientes!: Cliente[];
  produtos = [] as any;
  tablet_id: any;

  constructor(
    private serviceClientes: ClientesService,
    private router: Router,
    private formBuilder: FormBuilder,
    private produtosService: ProdutosService,
    private AgviewsConnectService: AgviewsConnectService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
  ) {
    this.tabletForm = this.formBuilder.group({
      fk_cliente: ['', Validators.required],
      fk_produto: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.tablet_id = this.activatedRoute.snapshot.paramMap.get('sr_id')!;
    this.listarClientes();
    this.listarProdutos();
    this.listarPorId();
  }

  listarClientes() {
    this.serviceClientes.listarServiceClientes().subscribe((resp: any) => {
      this.clientes = resp;
    })
  }

  listarProdutos() {
    this.produtosService.listarService().subscribe((resp: any) => {
      this.produtos = resp.filter(function (elem: any) {
        return elem.sr_id != 1
      })
    }, (error: any) => {
      this.alertService.error("Algo deu errado.");
      this.cancelar();
    })
  }

  listarPorId(): void {
    this.AgviewsConnectService.buscarId(this.tablet_id).subscribe((resp: any) => {
      if (resp == null) {
        this.alertService.error('Não é possível editar comunicador');
        this.cancelar();
      }
      this.tabletForm.get('fk_cliente')?.setValue(resp.fk_cliente);
      this.tabletForm.get('fk_produto')?.setValue(resp.fk_produto);

      this.mudarClienteLocalStorage(resp.fk_cliente);
    }, (error: any) => {
      this.cancelar();
    })
  }

  cancelar() {
    this.router.navigate(['configuracao/agviewsConnect']);
  }

  editar() {
    this.AgviewsConnectService.editar(this.tabletForm.value, this.tablet_id).subscribe((resp: any) => {
      this.alertService.success();
      this.cancelar();
    }, (error: any) => {
      this.alertService.error(error.error.mensagem);
    });
  }

  mudarClienteLocalStorage(idCliente: any) {
    localStorage.setItem('cliente', idCliente);
  }
}
